import { render } from "./HoSoXeCuaToi.vue?vue&type=template&id=468f422e&scoped=true"
import script from "./HoSoXeCuaToi.vue?vue&type=script&lang=js"
export * from "./HoSoXeCuaToi.vue?vue&type=script&lang=js"

import "./HoSoXeCuaToi.vue?vue&type=style&index=0&id=468f422e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-468f422e"]])

export default __exports__